export const enum OrderActionType {
  capture = 'capture',
  refund = 'refund',
  payout = 'payout',
  order = 'order'
}
